import React, { useState } from "react";
import axios from "axios";
import { fetchAuthSession } from "@aws-amplify/auth";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
const API_VERSIONS = ["v1", "v2", "v3", "v4", "v5"];

export const ApiRequests = () => {
  const [apiVersion, setApiVersion] = useState("v1");
  const [apiPath, setApiPath] = useState("");
  const [requestBody, setRequestBody] = useState("");
  const [requestBodyError, setRequestBodyError] = useState<string>(); // TODO: Use this to show error message [optional
  const [httpMethod, setHttpMethod] = useState("GET"); // Default to GET
  const [response, setResponse] = useState("");

  const makeApiCall = async () => {
    try {
      let response;

      setResponse("Loading...");

      const accessToken = (
        await fetchAuthSession()
      ).tokens?.idToken?.toString();

      if (!accessToken) {
        console.error("No auth token found for API request");
        throw new Error("No auth token found");
      }

      const url = `${process.env.REACT_APP_API_BASE_URL}/${apiVersion}${apiPath}`;

      if (httpMethod === "GET") {
        response = await axios.get(url, {
          headers: {
            Authorization: accessToken,
          },
        });
      } else if (httpMethod === "POST") {
        response = await axios.post(url, JSON.parse(requestBody), {
          headers: {
            Authorization: accessToken,
            "Content-Type": "application/json",
          },
        });
      } else if (httpMethod === "PUT") {
        response = await axios.put(url, JSON.parse(requestBody), {
          headers: {
            Authorization: accessToken,
            "Content-Type": "application/json",
          },
        });
      } else if (httpMethod === "DELETE") {
        response = await axios.delete(url, {
          headers: {
            Authorization: accessToken,
          },
        });
      }

      setResponse(JSON.stringify(response?.data, null, 2));
    } catch (error) {
      console.error(error);
      setResponse(JSON.stringify(error, null, 2));
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        AWS Cognito Authenticated API Caller
      </Typography>
      <FormControl fullWidth variant="outlined" margin="normal">
        <InputLabel>HTTP Method</InputLabel>
        <Select
          label="HTTP Method"
          value={httpMethod}
          onChange={(e) => {
            setHttpMethod(e.target.value);
            if (e.target.value === "GET" || e.target.value === "DELETE") {
              setRequestBody("");
            }
          }}
        >
          <MenuItem value="GET">GET</MenuItem>
          <MenuItem value="POST">POST</MenuItem>
          <MenuItem value="PUT">PUT</MenuItem>
          <MenuItem value="DELETE">DELETE</MenuItem>
        </Select>
      </FormControl>
      <Box sx={{ display: "flex", gap: 1, mt: 2, mb: 1 }}>
        <FormControl variant="outlined" sx={{ minWidth: 100 }}>
          <InputLabel>Version</InputLabel>
          <Select
            label="Version"
            value={apiVersion}
            onChange={(e) => setApiVersion(e.target.value)}
          >
            {API_VERSIONS.map((v) => (
              <MenuItem key={v} value={v}>
                {v}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          fullWidth
          label="API Path"
          variant="outlined"
          value={apiPath}
          onChange={(e) => setApiPath(e.target.value)}
        />
      </Box>
      <TextField
        fullWidth
        label="Request Body"
        variant="outlined"
        disabled={httpMethod === "GET" || httpMethod === "DELETE"}
        multiline
        rows={4}
        value={requestBody}
        onChange={(e) => {
          setRequestBody(e.target.value);
          if (e.target.value !== "") {
            try {
              JSON.parse(e.target.value);
              setRequestBodyError(undefined);
            } catch (error: any) {
              setRequestBodyError(
                `Request body must be valid JSON if set: error.message`,
              );
            }
          } else {
            setRequestBodyError(undefined);
          }
        }}
        error={requestBodyError ? true : false}
        margin="normal"
      />
      <Button
        variant="contained"
        color="primary"
        onClick={makeApiCall}
        disabled={!apiPath}
      >
        Make API Call
      </Button>
      <Box mt={2}>
        <Typography variant="h6">API Response:</Typography>
        <pre>{response}</pre>
      </Box>
    </Container>
  );
};
